















































import type { Lesson } from '@/models/lesson';
import { Component, Prop, Vue } from 'vue-property-decorator';
import LessonContainer from './LessonContainer.vue';

@Component({
    name: 'LessonsList',
    components: {
        LessonContainer,
    },
})
export default class LessonsList extends Vue {
    @Prop() private lessons: Lesson[];
    @Prop() private level: number;
    @Prop({ default: false }) private editButton: boolean;
    @Prop({ default: false }) private details: boolean;
    @Prop({ default: false }) private orderButton: boolean;
    @Prop({ default: false }) private moreInfoButton: boolean;
    @Prop({ default: false }) private checkbox: boolean;
    @Prop() private value: Lesson[];
    @Prop({ default: false }) private parentCheckBox: boolean;
    @Prop({ default: () => [] }) private checkedParentLesson: Lesson[];
    @Prop({ default: null }) private disableLesson: Lesson | null;

    get checkedLessons() {
        if (this.checkbox) {
            return this.value;
        } else {
            return [];
        }
    }

    // noinspection JSUnusedGlobalSymbols
    set checkedLessons(val) {
        this.$emit('input', val);
    }

    private haveSubLessons(lesson: Lesson) {
        return lesson.sub_lessons && lesson.sub_lessons.length > 0;
    }
}
